var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
var Environment = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production'
};
var DomainName = {
  BIOMAGE: 'app.trailmaker.parsebiosciences.com',
  BIOMAGE_STAGING: 'staging.trailmaker.parsebiosciences.com'
};
var AccountId = {
  BIOMAGE: '242905224710'
};
var ssrGetDeploymentInfo = function ssrGetDeploymentInfo() {
  var currentEnvironment = null;
  if (!process.env) {
    throw new Error('ssrGetDeploymentInfo must be called on the server side. Refer to `store.networkResources.environment` for the actual environment.');
  }
  if (process.env.NODE_ENV === 'test') {
    return {
      environment: Environment.DEVELOPMENT,
      domainName: DomainName.BIOMAGE
    };
  }
  switch (process.env.K8S_ENV) {
    case 'production':
      currentEnvironment = Environment.PRODUCTION;
      break;
    case 'staging':
      currentEnvironment = Environment.STAGING;
      break;
    default:
      currentEnvironment = Environment.DEVELOPMENT;
      break;
  }
  var domainName = currentEnvironment !== Environment.DEVELOPMENT ? process.env.DOMAIN_NAME : DomainName[process.env.DEV_ACCOUNT];
  return {
    environment: currentEnvironment,
    domainName: domainName
  };
};

// Set by _app from the redux store. Server code can't use it because its API calls
// run in getInitialProps, before _app renders, so it reads the env directly.
var browserDomainName = null;
var setUpDomainName = function setUpDomainName(domainName) {
  browserDomainName = domainName;
};
var getDomainName = function getDomainName() {
  return isBrowser ? browserDomainName : ssrGetDeploymentInfo().domainName;
};

// Using module.exports instead of export allows next.config.js to use it
module.exports = {
  isBrowser: isBrowser,
  ssrGetDeploymentInfo: ssrGetDeploymentInfo,
  getDomainName: getDomainName,
  setUpDomainName: setUpDomainName,
  DomainName: DomainName,
  AccountId: AccountId,
  Environment: Environment
};